import { Component } from '@angular/core';

import { SnLayoutService } from '../../services/layout.service';

@Component({
  selector: 'sn-layout-secondary-navbar-collapse-button',
  templateUrl: './layout-secondary-navbar-collapse-button.component.html',
  styleUrls: ['./layout-secondary-navbar-collapse-button.component.scss'],
})
export class LayoutSecondaryNavbarCollapseButtonComponent {
  constructor(private readonly _layout: SnLayoutService) {}

  get collapsed(): boolean {
    return this._layout.navbar.collapsed;
  }

  get canSeeSecondaryNavbar(): boolean {
    return this._layout.navbar.canSeeSecondaryNavbar;
  }

  public setSecondaryNavbarHidden(bool: boolean): void {
    this._layout.navbar.setSecondaryNavbarHidden(bool);
  }
}
